// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__91oC6","clinicsSelect":"styles_clinicsSelect__21MSy"};